import { render, staticRenderFns } from "./SocialPlanDialog.vue?vue&type=template&id=169895ec&"
import script from "./SocialPlanDialog.vue?vue&type=script&lang=js&"
export * from "./SocialPlanDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports